import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "common-recipe-foodids-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonRecipeFoodIdItem = _resolveComponent("CommonRecipeFoodIdItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.foodIds, (item) => {
      return (_openBlock(), _createBlock(_component_CommonRecipeFoodIdItem, {
        class: "common-recipe-foodids-item",
        key: item.id,
        icon: item.icon
      }, null, 8, ["icon"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}